import { useAlerts } from '../../context/AlertsContext';
import { Link } from 'react-router-dom';

export default function AlertToaster() {
  const { toasts, dismissToast } = useAlerts();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[100] flex w-80 max-w-[90vw] flex-col gap-2">
      {toasts.map((t) => {
        const a = t.alert;
        const isError = a.level === 'error' || a.level === 'critical';
        const accent = isError ? 'border-l-error-500' : 'border-l-warning-500';
        return (
          <div
            key={t.id}
            className={`rounded-lg border border-dark-700 border-l-4 ${accent} bg-dark-800 p-3 shadow-lg`}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1">
                <p className="text-sm font-semibold text-dark-100">
                  {isError ? '⚠️ Error de archivo' : '🔔 Alerta'}
                </p>
                <p className="mt-1 break-words text-sm text-dark-200">{a.message}</p>
              </div>
              <button
                onClick={() => dismissToast(t.id)}
                className="text-dark-400 hover:text-dark-100"
                aria-label="Cerrar"
              >
                ✕
              </button>
            </div>
            <Link
              to="/alerts"
              onClick={() => dismissToast(t.id)}
              className="mt-2 inline-block text-xs font-medium text-primary-400 hover:underline"
            >
              Ver alertas
            </Link>
          </div>
        );
      })}
    </div>
  );
}
